function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.912 11.122l3.435 2.073c.541.327 1.21-.159 1.066-.775l-.912-3.907 3.035-2.63c.479-.414.223-1.2-.407-1.253l-3.995-.338L7.57.604C7.324.023 6.5.023 6.253.604L4.69 4.292.695 4.63c-.63.054-.886.84-.407 1.253l3.035 2.63-.912 3.907c-.144.616.525 1.102 1.066.775l3.435-2.073z",
  transform: "translate(-613 -1499) translate(0 670) translate(230 108) translate(0 675) translate(205 39) translate(123 7) translate(55.987)"
});

var SvgIconStar = function SvgIconStar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-star.463451f3.svg";
export { ForwardRef as ReactComponent };